import initialState from './initialState';
import { actionTypes } from './actions';

export default function accountsAbroadListFiltersReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_BANK:
      return state.set('bank', action.payload);
    case actionTypes.SET_ACCOUNT_STATUS:
      return state.set('accountStatus', action.payload);
    default:
      return state;
  }
}
